const elasticConfig = {
    post: {
        filterLayout: 'ElasticFilterDefaultLayout',
        listLayout: 'ElasticListDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        elaIndex: 'map_data',
        elaType: '_doc',
        pageRow: 10,
        paginationType: 'firstInitPage',
        listApiParamSet: {
            query: {
                bool: {
                    must: [
                        {match: {"type": 'post'}},
                    ]
                }
            },
        },
        sortOptions: {
        },
        startSort: {},
        isFirstGet: true,
        isGetFirst: true,
        checkLive: false,
        getAlarmLive: false,
        checkEnd: false,
        checkCafe: false,
    },
    live: {
        filterLayout: 'ElasticFilterLiveLayout',
        listLayout: 'ElasticListLiveLayout',
        paginationLayout: 'PaginationDefaultLayout',
        elaIndex: 'map_data',
        elaType: '_doc',
        pageRow: 10,
        paginationType: 'firstInitPage',
        listApiParamSet: {
            query: {
                bool: {
                    must: [
                        {match: {"type": 'live'}},
                    ]
                }
            },
        },
        sortOptions: {
            default: [{'bj_starttime':'asc' }, {'created_at': 'desc'}],
        },
        startSort: {key: 'default', order: 'asc'},
        isFirstGet: true,
        isGetFirst: true,
        checkLive: true,
        getAlarmLive: false,
        checkEnd: false,
        checkCafe: false,

    },
    endLive: {
        filterLayout: 'ElasticFilterEndLiveLayout',
        listLayout: 'ElasticListEndLiveLayout',
        paginationLayout: 'PaginationDefaultLayout',
        elaIndex: 'map_data',
        elaType: '_doc',
        pageRow: 10,
        paginationType: 'firstInitPage',
        listApiParamSet: {
            query: {
                bool: {
                    must: [
                        {match: {"type": 'live'}},
                        {match: {'bj_live': 2}},
                    ]
                }
            },
        },
        sortOptions: {
            default: [{'updated_at':'desc' }, {'created_at': 'desc'}],
        },
        startSort: {key: 'default', order: 'desc'},
        isFirstGet: true,
        isGetFirst: true,
        checkLive: false,
        getAlarmLive: false,
        checkEnd: false,
        checkCafe: false,
    },
    cafeLive: {
        filterLayout: 'ElasticFilterCafeLiveLayout',
        listLayout: 'ElasticListCafeLiveLayout',
        paginationLayout: 'PaginationDefaultLayout',
        elaIndex: 'map_data',
        elaType: '_doc',
        pageRow: 10,
        paginationType: 'firstInitPage',
        listApiParamSet: {
            query: {
                bool: {
                    must: [
                        {match: {"type": 'live'}},
                    ]
                }
            },
        },
        sortOptions: {
            default: [{'bj_starttime':'asc' }, {'created_at': 'desc'}],
        },
        startSort: {key: 'default', order: 'asc'},
        isFirstGet: true,
        isGetFirst: true,
        checkLive: true,
        getAlarmLive: false,
        checkEnd: false,
        checkCafe: true,
    },
    cafeEndLive: {
        filterLayout: 'ElasticFilterCafeEndLiveLayout',
        listLayout: 'ElasticListCafeEndLiveLayout',
        paginationLayout: 'PaginationDefaultLayout',
        elaIndex: 'map_data',
        elaType: '_doc',
        pageRow: 10,
        paginationType: 'firstInitPage',
        listApiParamSet: {
            query: {
                bool: {
                    must: [
                        {match: {"type": 'live'}},
                        {match: {'bj_live': 2}},
                    ]
                }
            },
        },
        sortOptions: {
            default: [{'updated_at':'desc' }, {'created_at': 'desc'}],
        },
        startSort: {key: 'default', order: 'desc'},
        isFirstGet: true,
        isGetFirst: true,
        checkLive: false,
        getAlarmLive: false,
        checkEnd: true,
        checkCafe: true,
    },
    cafePost: {
        filterLayout: 'ElasticFilterDefaultLayout',
        listLayout: 'ElasticListCafePostLayout',
        paginationLayout: 'PaginationDefaultLayout',
        elaIndex: 'map_data',
        elaType: '_doc',
        pageRow: 10,
        paginationType: 'firstInitPage',
        listApiParamSet: {
            query: {
                bool: {
                    must: [
                        {match: {"type": 'post'}},
                    ]
                }
            },
        },
        sortOptions: {
        },
        startSort: {},
        isFirstGet: true,
        isGetFirst: true,
        checkLive: false,
        getAlarmLive: false,
        checkEnd: false,
        checkCafe: true,
    },
}
export default {
    methods: {
        returnElasticConfig(type) {
            return elasticConfig[type];
        },
    },
    elasticDefaultBody: {
        query: {
            bool: {
                must: []
            }
        },
    },
    filterConfig: {
        cr: {
            type: 'between',
            classname: 'filterDate',
            option: {
                ela_dataField: 'created_at'
            },
        },
        ti: {
            type: 'query',
            classname: 'filterInput',
            option: {
                ela_dataField: 'wr_subject'
            }
        },
        num: {
            type: 'query',
            classname: 'filterInput',
            option: {
                ela_dataField: 'key',
            }
        },
        mid: {
            type: 'query',
            classname: 'filterInput',
            option: {
                ela_dataField: 'Writer.mb_id'
            }
        },
        mni: {
            type: 'query',
            classname: 'filterInput',
            option: {
                ela_dataField: 'Writer.mb_nick'
            }
        },
        lst: {
            type: 'match',
            classname: 'filterConnect',
            option: {
                ela_dataField: 'bj_live',
            },
        },
        lsd: {
            type: 'between',
            classname: 'filterDate',
            option: {
                ela_dataField: 'bj_starttime'
            },
        },
        led: {
            type: 'between',
            classname: 'filterDate',
            option: {
                ela_dataField: 'updated_at'
            },
        },
    }
}
